import { render } from "./NotificationExportPopup.vue?vue&type=template&id=2a6aab6a&scoped=true&ts=true"
import script from "./NotificationExportPopup.vue?vue&type=script&lang=ts"
export * from "./NotificationExportPopup.vue?vue&type=script&lang=ts"

import "./NotificationExportPopup.vue?vue&type=style&index=0&id=2a6aab6a&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6aab6a"]])

export default __exports__